import { render, staticRenderFns } from "./OriginSelection.vue?vue&type=template&id=75c7af10&scoped=true&"
import script from "./OriginSelection.vue?vue&type=script&lang=js&"
export * from "./OriginSelection.vue?vue&type=script&lang=js&"
import style0 from "./OriginSelection.vue?vue&type=style&index=0&id=75c7af10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c7af10",
  null
  
)

export default component.exports